import WhatChooseUs from "components/homepage/whyChooseUs";
import GetInTouch from "components/getInTouch";
import React, { useState } from "react";
import MidSubText from "./midSubText";
import Layout from "components/layout";
import SEO from "components/seo";
import { Link } from "gatsby";
import QuotePopUp from "components/popup/quotePopUp/index";
import OptimizedImage from "hooks/OptimizedImage";

export default function Index(props) {
  const [open, setOpen] = useState(false);
  const {
    pageContext: {
      data: { data },
    },
  } = props;

  return (
    <Layout>
      <SEO title={data.seo_project_title} description={data.seo_project_meta_desc} keywords={data.seo_project_meta_keywords} slug={data.slug} />
      <div className="bannerImage recent-bg bg-no-repeat bg-cover bg-center text-white pb-32">
        <div className=" mx-auto  pb-8 sm:w-[90%] w-[80%] pt-20 max-w-6xl">
          <h1 className="text-[26px] sm:text-[36px] md:text-[50px] sm:leading-[60px] inline-block font-medium w-auto lg:max-w-2xl font-riot">
            {data.title_x || data.seo_h1 || data.seo_project_title}
          </h1>
          <br />
          <div className="bg-black bg-opacity-50 bg-no-repeat px-4 font-primary text-[14px] sm:text-2xl mt-7 inline-flex flex-col lg:flex-row gap-4 lg:gap-5 lg:items-center lg:mt-7">
            <div className="flex items-center">
            <OptimizedImage
                src="https://tomedes.gumlet.io/frontend/images/banner/check_sign.svg"
                alt={""}
                className="w-6 h-6 mr-4"
              />
              <span className="">24/7 Human Support</span>
            </div>
            <div className="flex items-center">
            <OptimizedImage
                src="https://tomedes.gumlet.io/frontend/images/banner/check_sign.svg"
                alt={""}
                className="w-6 h-6 mr-4"
              />
              <span className="">1 Year Guarantee</span>
            </div>
            <div className="flex items-center">
            <OptimizedImage
                src="https://tomedes.gumlet.io/frontend/images/banner/check_sign.svg"
                alt={""}
                className="w-6 h-6 mr-4"
              />
              <span className="content-left">95,000 Business Customers</span>
            </div>
          </div>
          <div className="grid grid-cols-1 py-6 space-y-6 text-center md:flex md:flex-row md:align-baseline md:items-center md:space-x-6 md:space-y-0 font-opensans mt-7">
            <Link
              to="/quote"
              className="fr-btn1 tomedes-button green-btn-hv text-new ruppercase rounded-full py-4 bg-orange text-white text-sm cursor-pointer w-60  font-semibold font-primary hover:bg-[#ff9a16] transition-colors duration-300"
            >
              Get a Free Quote
            </Link>
            <a
              onClick={() => setOpen(true)}
              className="hidden sm:inline-block fr-btn2 tomedes-button uppercase rounded-full bg-white py-4 text-black text-sm  cursor-pointer w-60 font-semibold font-primary "
            >
              Contact Us
            </a>
            <Link to="/contactus.php" className="sm:hidden fr-btn2 tomedes-button uppercase rounded-full bg-white py-4 text-black text-sm  cursor-pointer w-60 font-semibold font-primary ">
              Contact us
            </Link>
          </div>
        </div>
      </div>
      <QuotePopUp open={open} setOpen={setOpen} />
      <MidSubText data={data} />
      {/* <WhatChooseUs backgroundCol="bg-darkBlue" /> */}
      <GetInTouch />
    </Layout>
  );
}
